import { PublicPageLoader } from '@/features/public-pages/components/PublicPageLoader';

/**
 * Public Due Diligence Platform page (`/due-diligence-platform`), fully
 * CMS-driven (MYN-269, `02-design.md` §23). Every section renders from the
 * `due-diligence-platform` page's content via the public read API - no
 * hardcoded copy lives here. Content source is the client's docx, not this
 * page's Figma frame (A-131); layout, section design, and color palette match
 * the shipped Home/Benefits/Investors/Trusted Partners pages.
 * Loading/not-published/error states are shared across every public page via
 * `PublicPageLoader`.
 */
export function DueDiligencePlatformPage() {
  return <PublicPageLoader slug="due-diligence-platform" />;
}
